import { render, staticRenderFns } from "./SchoolPickerCombined.vue?vue&type=template&id=d861fbe8&"
import script from "./SchoolPickerCombined.vue?vue&type=script&lang=js&"
export * from "./SchoolPickerCombined.vue?vue&type=script&lang=js&"
import style0 from "./SchoolPickerCombined.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports